import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "pie-chart-2, graph, chart, statistics" }, [
      _createElementVNode("g", { id: "vector" }, [
        _createElementVNode("path", {
          d: "M17.5539 6.9547C16.9637 4.76211 15.237 3.03543 13.0444 2.44529C12.8169 2.38404 12.7031 2.35341 12.5903 2.38672C12.4982 2.41394 12.4034 2.48657 12.3532 2.56849C12.2917 2.66873 12.2917 2.79902 12.2917 3.0596V7.04079C12.2917 7.27414 12.2917 7.39082 12.3371 7.47995C12.377 7.55835 12.4408 7.62209 12.5192 7.66204C12.6083 7.70745 12.725 7.70745 12.9584 7.70745H16.9395C17.2001 7.70745 17.3304 7.70745 17.4306 7.64598C17.5126 7.59574 17.5852 7.50098 17.6124 7.40881C17.6457 7.29604 17.6151 7.18226 17.5539 6.9547Z",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          d: "M16.0417 10.8325C16.0417 14.6294 12.9636 17.7075 9.16669 17.7075C5.36973 17.7075 2.29169 14.6294 2.29169 10.8325C2.29169 7.0355 5.36973 3.95745 9.16669 3.95745C9.23754 3.95745 9.30814 3.95853 9.37847 3.96065V8.62431C9.37847 9.32437 9.37847 9.67441 9.51472 9.9418C9.63456 10.177 9.82578 10.3682 10.061 10.4881C10.3284 10.6243 10.6784 10.6243 11.3785 10.6243H16.0386C16.0407 10.6934 16.0417 10.7628 16.0417 10.8325Z",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }